export default "__VITE_ASSET__Bs0FLkR6__"